import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import hikegroups_logo_green from './assets/hikegroups_logo_green.png';
import CreateEvent from './CreateEvent';
import UserAvatarDropdown from './UserAvatarDropdown';
import BlogSection from './BlogSection';
import './App.css';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function HomePage() {
  const [user, setUser] = useState(null);
  const [showCreateEvent, setShowCreateEvent] = useState(false);
  const [events, setEvents] = useState([]);
  const [activeTab, setActiveTab] = useState('public'); // 'public', 'blog', or 'myhikes'
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/user/', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })
      .then(res => (res.ok ? res.json() : null))
      .then(data => setUser(data))
      .catch(err => console.error('Error fetching user:', err));
  }, []);

  useEffect(() => {
    fetch("/api/events/", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include"
    })
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then(data => {
        const sortedEvents = data.sort((a, b) => new Date(a.event_time) - new Date(b.event_time));
        setEvents(sortedEvents);
      })
      .catch(err => console.error("Failed to fetch events:", err));
  }, []);

  const handleCreateEvent = (newEventData) => {
    if (!user) {
      window.location.href = '/accounts/signup/';
      return;
    }
    fetch("/api/events/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCookie("csrftoken")
      },
      credentials: "include",
      body: JSON.stringify({
        name: newEventData.name,
        location: newEventData.location,
        event_time: newEventData.time
      })
    })
      .then(res => {
        if (!res.ok) throw new Error("Failed to create event");
        return res.json();
      })
      .then(createdEvent => {
        setEvents(prevEvents => [...prevEvents, createdEvent]);
        setShowCreateEvent(false);
      })
      .catch(err => console.error(err));
  };

  // For "My Hikes": filter events where the user is organizer or a participant
  const myHikes = user ? events.filter(event => {
    return event.organizer === user.id || (event.participants && event.participants.some(p => p.id === user.id));
  }) : [];

  // Get today's date
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds and milliseconds to 0

  // Filter events to only show those that are today or in the future
  const futureEvents = events.filter(event => {
    const eventDate = new Date(event.event_time);
    eventDate.setHours(0, 0, 0, 0); // Also set the time of the event to 0
    return eventDate >= today;
  });

  return (
    <div>
      <header className="App-header">
        <img src={hikegroups_logo_green} alt="Hiking Groups Logo" className="App-logo" />
        <div className="header-right">
          <UserAvatarDropdown />
        </div>
      </header>

      <div className="tabs">
        <button className={activeTab === 'public' ? 'active-tab' : ''} onClick={() => setActiveTab('public')}>
          Public Events
        </button>
        <button className={activeTab === 'blog' ? 'active-tab' : ''} onClick={() => setActiveTab('blog')}>
          Blog
        </button>
        <button className={activeTab === 'myhikes' ? 'active-tab' : ''} onClick={() => setActiveTab('myhikes')}>
          My Hikes
        </button>
      </div>

      <main>
        {activeTab === 'public' && (
          <section className="events-list">
            <div className="events-grid">
              {futureEvents.map((event) => (
                <div
                  key={event.id}
                  className="event-card-homepage"
                  onClick={() => navigate(`/events/${event.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={event.image} alt={event.name} className="event-image-homepage" />
                  <h3>{event.name}</h3>
                  <p>{new Date(event.event_time).toLocaleDateString()}</p>
                {/* Organizer avatar + name */}
		  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
		    <img
		      src={event.organizer_profile_picture || '/default-avatar.png'}
		      alt={event.organizer_username}
		      style={{ width: '35px', height: '35px', borderRadius: '50%', marginRight: '8px' }}
		    />
		    <p>Organizer: {event.organizer_username}</p>
		  </div>
		  </div>
              ))}
            </div>
          </section>
        )}
        {activeTab === 'blog' && (
          <section className="blog-section-container">
            <BlogSection />
          </section>
        )}
        {activeTab === 'myhikes' && (
          <section className="events-list">
            {user ? (
              myHikes.length > 0 ? (
                <div className="events-grid">
                  {myHikes.map((event) => (
                    <div
                      key={event.id}
                      className="event-card-homepage"
                      onClick={() => navigate(`/events/${event.id}`)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src={event.image} alt={event.name} className="event-image-homepage" />
                      <h3>{event.name}</h3>
                      <p>{new Date(event.event_time).toLocaleDateString()}</p>
                      <p>Organizer: {event.organizer_username}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p>You haven't joined or organized any events yet.</p>
              )
            ) : (
              <p>Please log in to view your hikes.</p>
            )}
          </section>
        )}
      </main>

      <footer className="App-footer">
	  <button  className="create-event-button"
	  onClick={() => {
	    if (!user) {
	      window.location.href = '/accounts/signup/';
	    } else {
	      setShowCreateEvent(true);
	    }
	  }}
	>
	  + Create Event
	</button>
      </footer>

      {showCreateEvent && (
        <CreateEvent onClose={() => setShowCreateEvent(false)} onSave={handleCreateEvent} />
      )}
    </div>
  );
}

export default HomePage;

